import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setFontSizeCoefThunk } from '@/actions';
import WebComponentApp from './web_component';

const AppContainer = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setFontSizeCoefThunk());
  }, []);

  return <WebComponentApp />;
};

export default AppContainer;
